import { render, staticRenderFns } from "./controlEscolar.vue?vue&type=template&id=1cc5c042&"
import script from "./controlEscolar.vue?vue&type=script&lang=js&"
export * from "./controlEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports